import _lib from '../_lib';
import active from './active/index';
import {ProvidersNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'providers';
  let activations = [
    {
      name: 'providers',
      test: api.messageIs(ProvidersNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};
